import React from 'react';
import DOMPurify from 'dompurify';

const ExameTexto = ({ exame }) => {
    const sanitizedDescricao = DOMPurify.sanitize(exame.descricao);
    return(
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-6 mb-sm-20" >
                    <div dangerouslySetInnerHTML={{ __html: sanitizedDescricao }} />
                </div>
            </div>
        </div>
    );
}

export default ExameTexto;